import { render, staticRenderFns } from "./AboutSectionHeader.vue?vue&type=template&id=14b1e386&scoped=true"
import script from "./AboutSectionHeader.vue?vue&type=script&lang=js"
export * from "./AboutSectionHeader.vue?vue&type=script&lang=js"
import style0 from "./AboutSectionHeader.vue?vue&type=style&index=0&id=14b1e386&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b1e386",
  null
  
)

export default component.exports